<template>
  <div class="content">
    <div
      v-for="i in imgNum"
      :key="'bc-' + i"
      class="img-wrap"
    >
      <div v-if="i === 3" class="gif-container">
        <img src="~@/assets/image/background/order-detail-gif1.gif">
        <img src="~@/assets/image/background/order-detail-gif2.gif">
      </div>
      <img
        class="img"
        :src="getImg(i)"
      />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      imgHead: 'order',
      imgNum: 6
    }
  },
  methods: {
    getImg(i) {
      return require(`@/assets/image/background/${this.imgHead}-${this.$util.nativeType ? 'mobile' : 'pc'}-${i}.png`)
    }
  },
}
</script>
<style lang="scss">
  body {
    overflow-y: auto !important;
  }
</style>
<style lang="scss" scoped>
  .content {
    font-size: 0;
    .img {
      width: 100%;
      user-select: none;
      -webkit-user-select: none;
    }
  }
  .img-wrap {
    position: relative;
  }
  @media screen and (max-width: 599px) {
    .gif-container {
      width: 100vw;
      position: absolute;
      top: 9px;
      display: flex;
      justify-content: center;
      img {
        margin: 0 3px;
        height: 145px;
      }
    }
  }
  @media screen and (min-width: 600px) {
    .gif-container {
      position: absolute;
      width: 100%;
      top: 25px;
      display: flex;
      justify-content: center;
      img {
        margin: 0 10px;
        height: 245px;
      }
    }
    .content {
      width: 1200px;
      margin: 0 auto;
    }
  }
</style>